import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Drawer,
  Indicator,
  Text,
  Tabs,
  Title,
  Badge,
  Popover,
  Loader,
  Flex,
  UnstyledButton,
} from "@mantine/core";
import { FiBell } from "react-icons/fi";
import { RxHamburgerMenu } from "react-icons/rx";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { PiWarningFill } from "react-icons/pi";
import { IoCloseOutline } from "react-icons/io5";
import {
  getNotifications,
  readAllNotifications,
  readNotification,
} from "../../services/notification";
import useStyles from "./style";
import NewNotificationCardComp from "../NewNotificationCardComp";
import NoteModalNew from "../NoteModal/NoteModalNew";
import { getSkaiTokenUsage } from "../../services/skaiTokens";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import { updateChangeSignature } from "../../services/signature";
import SignatureRequestModal from "../SignatureModal";
import NoteDrawer from "../NoteModal/NewNoteDesignCopy";
import SetupTwoFactorModal from "../SetupTwoFactorModal";
import { useDisclosure } from "@mantine/hooks";

const AppNavbar = ({ title, profile, isSidebarOpen, titleExtra }) => {
  const { classes } = useStyles();
  const [isReadAll, setIsReadAll] = useState();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [isLoading, setIsLoading] = useState([]);
  const [readAllLoading, setReadAllLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { singleNote } = useSelector((state) => state?.note);
  const { notifications, getNotificationLoading, notiCount, unreadCount } =
    useSelector((state) => state.notification);
  const [currentTab, setCurrentTab] = useState("all");

  // const { notiCount } = useSelector((state) => state.notification);
  // console.log("🚀 ~ AppNavbar ~ notiCount:", notiCount);

  const [noteType, setNoteType] = useState(null);
  const [isopen, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [view, setView] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [signatureModalOpened, setSignatureModalOpened] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const userId = profile?.user?.id || profile?.user?._id;
  const [dismissedPaymentBanner, setDismissedPaymentBanner] = useState(
    () => userId ? localStorage.getItem(`dismissedPaymentBanner_${userId}`) === "true" : false
  );
  const [dismissed2FABanner, setDismissed2FABanner] = useState(
    () => userId ? localStorage.getItem(`dismissed2FABanner_${userId}`) === "true" : false
  );
  useEffect(() => {
    if (userId) {
      setDismissedPaymentBanner(localStorage.getItem(`dismissedPaymentBanner_${userId}`) === "true");
      setDismissed2FABanner(localStorage.getItem(`dismissed2FABanner_${userId}`) === "true");
    }
  }, [userId]);

  const navigate = useNavigate();
  const [
    setupTwoFactorModalOpened,
    { open: setupTwoFactorModalOpen, close: setupTwoFactorModalClose },
  ] = useDisclosure(false);

  const handleOpenSignatureModal = (notification) => {
    setSelectedNotification(notification);
    setSignatureModalOpened(true);
  };

  const handleAcceptSignature = async () => {
    const payload = {
      signatureId: selectedNotification?.moduleId,
      staffId: selectedNotification?.staff?.id,
    };
    await updateChangeSignature(payload);
    setSignatureModalOpened(false);
  };

  // useEffect(() => {
  //   getNotificationsCount();
  // }, [notiCount]);

  const handleNotificationClick = () => {
    if (profile?.user?.type != "staff") {
      setIsOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleNotifyBillClick = () => {
    setPopoverOpened((prev) => !prev);
    getNotifications({ page: 1, limit: 10, client: "" });
    getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
  };

  let countUnreadNotif = 0;

  const allNotifications = Object.values(notifications).flat();

  const isAnyNotification = allNotifications?.map((notification) =>
    notification?.readedUsers?.includes(profile?.user?.id)
  );

  allNotifications.forEach((notification) => {
    if (notification?.readedUsers?.length === 0) {
      countUnreadNotif++;
    }
  });

  // const getData = async () => {
  //   try {
  //     let data = {
  //       page: 1,
  //       perPage: 2,
  //     };
  //     await getNotifications({
  //       page: data?.page,
  //       perPage: data?.perPage,
  //       client: "",
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getData = async (pageNum = 1) => {
    try {
      // let data = {
      //   page: pageNum,
      //   perPage: 10, // match backend limit
      // };
      const res = await getNotifications({
        page: pageNum,
        limit: 10,
        client: "",
        filter: currentTab === "unread" ? "unread" : undefined,
      });

      // assuming backend returns { notifications, totalPages }
      if (res) {
        // you'll probably need to set notifications in Redux or state
        // dispatch(setNotifications(res.notifications));
        setTotalPages(res.totalPages || 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewAll = () => {
    getData();
    setPopoverOpened(false);
    setDrawerOpened(true);
  };

  const handleReadNotification = async (notificationId) => {
    setIsLoading((prev) => [...prev, notificationId]);
    try {
      const response = await readNotification(notificationId);
      if (response) {
        await getData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      await getData();
      setIsLoading((prev) => prev?.filter((id) => id !== notificationId));
    }
  };

  const handleReadAllNotifications = async () => {
    try {
      setReadAllLoading(true);
      const response = await readAllNotifications();
      if (response) {
        return response?.message;
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      await getData();
      setReadAllLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [currentTab]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    getData(newPage);
  };

  const handleDismissPaymentBanner = () => {
    setDismissedPaymentBanner(true);
    if (userId) localStorage.setItem(`dismissedPaymentBanner_${userId}`, "true");
  };

  const handleDismiss2FABanner = () => {
    setDismissed2FABanner(true);
    if (userId) localStorage.setItem(`dismissed2FABanner_${userId}`, "true");
  };

  const navigateToUpdateCard = () => {
    // navigate(`/home/settings`, { state: { selectedTab: "method" } });
    navigate("/add-payment");
  };

  const navToSettingBusinessTab = () => {
    navigate(`/home/settings`, { state: { selectedTab: "business" } });
  };

  const currentDate = profile?.currentDate
    ? new Date(profile?.currentDate)
    : new Date();
  const cutoffDate = new Date("2026-3-19");
  return (
    <>
      <Box w={"100%"}>
        {!profile?.user?.role && profile?.subscription?.subscriptionFailed && !dismissedPaymentBanner ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              Your payment was unsuccessful. Please{" "}
              <UnstyledButton onClick={navigateToUpdateCard} className="link">
                update
              </UnstyledButton>{" "}
              your payment method to maintain your subscription.
            </p>
            <UnstyledButton
              className={classes.bannerCloseBtn}
              onClick={handleDismissPaymentBanner}
            >
              <IoCloseOutline size={20} color="#FFF" />
            </UnstyledButton>
          </Flex>
        ) : null}
        {/* {currentDate <= cutoffDate && profile?.user?.twoFactorVerified === false ? ( */}
        {profile?.user?.twoFactorVerified === false && !dismissed2FABanner ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              <UnstyledButton
                className="link"
                onClick={setupTwoFactorModalOpen}
              >
                Setup two factor authentication
              </UnstyledButton>{" "}
              to protect client data.
            </p>
            <UnstyledButton
              className={classes.bannerCloseBtn}
              onClick={handleDismiss2FABanner}
            >
              <IoCloseOutline size={20} color="#FFF" />
            </UnstyledButton>
          </Flex>
        ) : null}
        {currentDate <= cutoffDate && profile?.isFreeAccount && !profile?.user?.type ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              You’re currently on a free package that will expire in 14 days.
              To keep using all features without interruption, 
              <UnstyledButton
                className="link"
                onClick={() => navigate("/home/settings", { state: { selectedTab: "upgrade" } })}
              >
                please upgrade to the pro plan.
              </UnstyledButton>{" "}
            </p>
            <UnstyledButton
              className={classes.bannerCloseBtn}
              onClick={handleDismiss2FABanner}
            >
              <IoCloseOutline size={20} color="#FFF" />
            </UnstyledButton>
          </Flex>
        ) : null}

        {/* {currentDate <= cutoffDate && isIncompleteAddressDetails(profile) ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              <UnstyledButton
                className="link"
                onClick={navToSettingBusinessTab}
              >
                Incomplete address information
              </UnstyledButton>{" "}
              Please complete your address details. Non compliant users will be
              required to enroll by {moment(cutoffDate).format("MM/DD/YYYY")}
            </p>
          </Flex>
        ) : null} */}

        <Box className={classes.container}>
          <Box className={classes.left}>
            <button
              className={classes.hamburger}
              onClick={() => window.dispatchEvent(new CustomEvent("openMobileDrawer"))}
              aria-label="Open navigation menu"
            >
              <RxHamburgerMenu size={24} />
            </button>
            <Flex align="center" gap={10}>
              <Title order={2} pl={6} tt={"capitalize"}>
                {title}
              </Title>
              {titleExtra}
            </Flex>
          </Box>
          <Box className={classes.right}>
            <Popover
              trapFocus
              shadow="md"
              radius={10}
              offset={10}
              width={600}
              position="bottom-end"
              opened={popoverOpened}
              onChange={setPopoverOpened}
              styles={{
                dropdown: {
                  padding: 0,
                  maxWidth: "calc(100vw - 20px)",
                },
              }}
            >
              <Popover.Target>
                <Box
                  className={classes.notificationBorder}
                  onClick={handleNotifyBillClick}
                >
                  {isAnyNotification?.includes(false) ? (
                    <Indicator
                      color="red"
                      size={10}
                      inline
                      disabled={!isAnyNotification}
                    >
                      <FiBell size={24} style={{ margin: "0.3rem" }} />
                    </Indicator>
                  ) : (
                    <FiBell size={24} style={{ margin: "0.3rem" }} />
                  )}
                </Box>
              </Popover.Target>
              <Popover.Dropdown>
                {getNotificationLoading ? (
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "1rem",
                      height: "500px",
                    }}
                  >
                    <Loader color="var(--app-primary)" size="md" />
                  </Box>
                ) : (
                  <>
                    <Box className={classes.header}>
                      <Box className={classes.headerTitle}>
                        <Title order={3} fw={600}>
                          Notification
                        </Title>
                        {/* {countUnreadNotif > 0 && ( */}
                        {unreadCount > 0 && (
                          <Badge
                            variant="light"
                            color="red"
                            radius="xl"
                            size="md"
                          >
                            {unreadCount}
                            {/* {countUnreadNotif} New */}
                          </Badge>
                        )}
                      </Box>

                      <Button
                        loading={readAllLoading}
                        onClick={
                          isAnyNotification?.includes(false) &&
                          handleReadAllNotifications
                        }
                        variant="transparent"
                        styles={{
                          root: {
                            backgroundColor: "var(--app-primary)",
                            color: "var(--app-on-primary)",
                          },
                        }}
                        className={classes.readAllButton}
                      >
                        Read All
                      </Button>
                    </Box>
                    <Box className={classes.body}>
                      {notifications?.today?.length > 0 && (
                        <>
                          <Text ff="Inter" size="md" fw={400}>
                            Today
                          </Text>
                          {notifications?.today?.map((notification, index) => (
                            <NewNotificationCardComp
                              key={notification._id} // add key if available
                              notification={notification}
                              handleReadNotification={handleReadNotification}
                              isLoading={isLoading}
                              isReadAll={isReadAll}
                              profile={profile}
                              onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                              onClickNotification={handleNotificationClick}
                            />
                          ))}
                        </>
                      )}

                      {notifications?.yesterday?.length > 0 && (
                        <>
                          <Text ff={"Inter"} size="md" fw={400}>
                            Yesterday
                          </Text>

                          {notifications?.yesterday?.map((notification) => (
                            <NewNotificationCardComp
                              key={notification._id}
                              notification={notification}
                              handleReadNotification={handleReadNotification}
                              isLoading={isLoading}
                              isReadAll={isReadAll}
                              profile={profile}
                              onOpenSignatureModal={handleOpenSignatureModal}
                              onClickNotification={handleNotificationClick}
                            />
                          ))}
                        </>
                      )}

                      {notifications?.restOfThreeMonths?.length > 0 && (
                        <>
                          <Text ff={"Inter"} size="md" fw={400}>
                            Older
                          </Text>

                          {notifications?.restOfThreeMonths?.map(
                            (notification) => (
                              <NewNotificationCardComp
                                key={notification._id}
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onOpenSignatureModal={handleOpenSignatureModal}
                                onClickNotification={handleNotificationClick}
                              />
                            )
                          )}
                        </>
                      )}
                    </Box>
                    <Box className={classes.footer}>
                      <Button
                        size="md"
                        fullWidth
                        c={"var(--app-text)"}
                        variant="white"
                        onClick={handleViewAll}
                        styles={{
                          root: {
                            backgroundColor: "var(--app-surface)",
                            border: "1px solid var(--app-border)",
                            color: "var(--app-text)",
                            "&:hover": {
                              backgroundColor: "var(--app-surface-2)",
                            },
                          },
                        }}
                      >
                        View All
                      </Button>
                    </Box>
                  </>
                )}
              </Popover.Dropdown>
            </Popover>
            <NavLink to={"/home/settings"}>
              <Avatar
                size="lg"
                radius="xl"
                src={profile?.user?.photo}
                style={{ cursor: "pointer", flexShrink: 0 }}
                sx={{ "@media (max-width: 480px)": { width: 36, height: 36, minWidth: 36 } }}
              />
            </NavLink>
          </Box>
        </Box>
      </Box>

      {/* <UploadStaffDoc
        selectedFolder={n?.folder}
        userId={n?.userId}
        isDocument={true}
        uploadedFiles={n?.file}
      /> */}

      {/* view note drawer */}
      <NoteModalNew
        view={true}
        opened={isOpen}
        data={singleNote}
        title={"View Note"}
        close={() => setIsOpen(false)}
      />

      {/* edit note modal */}
      {/* <NoteModal */}
      <NoteDrawer
        data={singleNote}
        view={view}
        opened={isopen}
        setView={setView}
        noteType={noteType}
        title={"Add New Note"}
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType(null);
        }}
        // sortField={sortField}
        // sortOrder={sortOrder}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
        // selectedPatient={selectedPatient}
        // setSelectedPatient={setSelectedPatient}
      />

      <SignatureRequestModal
        opened={signatureModalOpened}
        onClose={() => setSignatureModalOpened(false)}
        onAccept={handleAcceptSignature}
        notification={selectedNotification}
      />

      <SetupTwoFactorModal
        opened={setupTwoFactorModalOpened}
        close={setupTwoFactorModalClose}
        profile={profile}
        isNavbar={true}
      />

      <Drawer
        size="clamp(300px, 90vw, 500px)"
        offset={8}
        radius="md"
        zIndex={1000}
        position="right"
        title="Notifications"
        opened={drawerOpened}
        className={classes.drawer}
        onClose={() => setDrawerOpened(false)}
      >
        {getNotificationLoading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem",
              marginTop: "1rem",
            }}
          >
            <Loader color="var(--app-primary)" size="md" />
          </Box>
        ) : (
          <Box className={classes.drawer}>
            <Tabs
              radius="md"
              color="gray"
              variant="default"
              defaultValue="all"
              value={currentTab}
              onTabChange={(value) => {
                if (value) {
                  setCurrentTab(value);
                  setPage(1);
                }
              }}
              className={classes.tabs}
            >
              <Tabs.List className={classes.tabsList}>
                <Tabs.Tab value="all">All</Tabs.Tab>
                <Tabs.Tab value="unread">Unread</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="all">
                {/* -----> Today <----- */}

                {notifications?.today?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Today
                    </Text>
                    {notifications?.today?.map((notification) => (
                      <Box key={notification._id} mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal}
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {/* -----> Yesterday <----- */}

                {notifications?.yesterday?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Yesterday
                    </Text>
                    {notifications?.yesterday?.map((notification) => (
                      <Box key={notification._id} mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal}
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {/* -----> Rest of three months <-----  */}

                {notifications?.restOfThreeMonths?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Older
                    </Text>
                    {notifications?.restOfThreeMonths?.map((notification) => (
                      <Box key={notification._id} mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
                <CustomBillingPagination
                  data={notiCount}
                  itemsPerPage={10}
                  currentPage={page}
                  handlePageChange={handlePageChange}
                />
              </Tabs.Panel>
              <Tabs.Panel value="unread">
                <Box>
                  {notifications?.today?.length > 0 ||
                  notifications?.yesterday?.length > 0 ||
                  notifications?.restOfThreeMonths?.length > 0 ? (
                    <>
                      {/* -----> Today <----- */}

                      {notifications?.today?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Today
                          </Text>
                          {notifications?.today?.map((notification) => (
                            <Box key={notification._id} mt={"1rem"}>
                              <NewNotificationCardComp
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onClickNotification={handleNotificationClick}
                                onOpenSignatureModal={handleOpenSignatureModal}
                              />
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* -----> Yesterday <----- */}

                      {notifications?.yesterday?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Yesterday
                          </Text>
                          {notifications?.yesterday?.map((notification) => (
                            <Box key={notification._id} mt={"1rem"}>
                              <NewNotificationCardComp
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onClickNotification={handleNotificationClick}
                                onOpenSignatureModal={handleOpenSignatureModal}
                              />
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* -----> Rest of three months <-----  */}

                      {notifications?.restOfThreeMonths?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Older
                          </Text>
                          {notifications?.restOfThreeMonths?.map(
                            (notification) => (
                              <Box key={notification._id} mt={"1rem"}>
                                <NewNotificationCardComp
                                  notification={notification}
                                  handleReadNotification={
                                    handleReadNotification
                                  }
                                  isLoading={isLoading}
                                  isReadAll={isReadAll}
                                  profile={profile}
                                  onClickNotification={handleNotificationClick}
                                  onOpenSignatureModal={
                                    handleOpenSignatureModal
                                  }
                                />
                              </Box>
                            )
                          )}
                        </Box>
                      )}
                      <CustomBillingPagination
                        data={notiCount}
                        itemsPerPage={10}
                        currentPage={page}
                        handlePageChange={handlePageChange}
                      />
                    </>
                  ) : (
                    <Box className={classes.empty}>
                      <Text size="md" color="var(--app-text-muted)" fw={400} ff={"Inter"}>
                        No unread notification.
                      </Text>
                    </Box>
                  )}
                </Box>
              </Tabs.Panel>
            </Tabs>
          </Box>
        )}
      </Drawer>
    </>
  );
};

export default AppNavbar;
